import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField
} from "@mui/material";
import { authStorageAtom } from "apps/web/src/atoms";
import { useAtomValue } from "jotai";
import React, { useState } from "react";

import {
  getLocalLocationList,
  setLocalLocationList
} from "../../../utils/localLocationList";

interface Props {
  visible: boolean;
  location?: string;
  setVisibility: (visible: boolean) => void;
  onLocationConfermation: (location: string) => void;
}

const LocationModal: React.FC<Props> = (props) => {
  const {
    visible,
    location: prevLocatioin,
    setVisibility,
    onLocationConfermation
  } = props;

  const authStorage = useAtomValue(authStorageAtom);
  const { user } = authStorage;

  const currentLocation =
    user?.company === "Immerxive" ? "straordinario" :
    prevLocatioin !== "ufficio" && prevLocatioin !== "casa"
      ? "altro"
      : prevLocatioin;

  const currentCustomLocation =
    currentLocation === "altro" ? prevLocatioin : undefined;


  const [location, setLocation] = useState(currentLocation);
  const [customLocation, setCustomLocation] = useState<string | undefined>(
    currentCustomLocation
  );
  const [locationList, setLocationList] = useState(getLocalLocationList());

  const _onLocationConfermation = () => {
    if (customLocation) {
      const _customLocation = customLocation.toLocaleLowerCase();
      // aggiungerla al localStorage solo se non presente
      let exist = false;
      locationList.forEach((element) => {
        if (element === _customLocation) {
          exist = true;
          return;
        }
      });
      if (!exist) {
        const newValue = _customLocation;
        setLocationList((s) => [...s, newValue]);
        setLocalLocationList([...locationList, newValue]);
      }
    }
    onLocationConfermation(
      customLocation !== undefined ? customLocation : location
    );
  };

  const onLocationChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    setLocation(value);
    setCustomLocation(undefined);
  };

  const onCustomLocationChange = (
    event: React.SyntheticEvent<Element, Event>,
    value: string | null
  ) => {
    // console.log("onCustomLocationChangevalue :>> ", value);
    if (value) setCustomLocation(value);
  };

  const handleClose = () => {
    setVisibility(false);
  };

  return (
    <Dialog title="Scegli location" open={visible}>
      <DialogTitle id="alert-dialog-title">Scegli location</DialogTitle>
      <DialogContent style={{minWidth: 300}}>
        <RadioGroup
          row
          aria-label="location"
          name="location"
          onChange={onLocationChange}
          value={location}
        >
          {user?.company === "Immerxive" ? (
            <FormControlLabel
              value="straordinario"
              control={<Radio />}
              label="Straordinario"
            />
          ) : (
          <>
          <FormControlLabel
            value="ufficio"
            control={<Radio />}
            label="Ufficio"
          />
          <FormControlLabel value="casa" control={<Radio />} label="Casa" />
          <FormControlLabel value="altro" control={<Radio />} label="Altro" />
          </>
          )}
        </RadioGroup>
        {location === "altro" && (
          <Autocomplete
            disablePortal
            freeSolo
            className="custom-location"
            size="small"
            options={locationList}
            value={customLocation}
            onChange={onCustomLocationChange}
            onInputChange={onCustomLocationChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Location"
                placeholder="Scrivi dove stai lavorando"
              />
            )}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Annulla</Button>
        <Button
          onClick={_onLocationConfermation}
          autoFocus
          disabled={
            location === "altro" &&
            (customLocation === undefined || customLocation === "")
          }
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LocationModal;
